// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  background-color: var(--color-card-background);
  padding: 15px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
}

.header {
  position: relative;
  text-align: center;
}
.header img {
  height: 240px;
  min-width: 100%;
  object-fit: cover;
}

.centered {
  position: absolute;
  width: 800px;
  top: 50%;
  left: 50%;
  font-size: 45px;
  font-weight: 700;
  color: white;
  transform: translate(-50%, -50%);
}

.sub-contentCase {
  padding: 0px 0px 0px 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
}

.sub-contentInstuct {
  padding: 10px 0px 0px 10px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/desktop/d-landing-page/customer-service-case/customer-service-case.component.scss"],"names":[],"mappings":"AAAA;EACE,8CAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AACA;EACE,kBAAA;EACA,kBAAA;AAEF;AADE;EACE,aAAA;EACA,eAAA;EACA,iBAAA;AAGJ;;AAAA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gCAAA;AAGF;;AAAA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAGF;;AADA;EACE,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAIF","sourcesContent":[".content {\n  background-color: var(--color-card-background);\n  padding: 15px;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n}\n.header {\n  position: relative;\n  text-align: center;\n  img {\n    height: 240px;\n    min-width: 100%;\n    object-fit: cover;\n  }\n}\n.centered {\n  position: absolute;\n  width: 800px;\n  top: 50%;\n  left: 50%;\n  font-size: 45px;\n  font-weight: 700;\n  color: white;\n  transform: translate(-50%, -50%);\n}\n\n.sub-contentCase{\n  padding: 0px 0px 0px 10px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n}\n.sub-contentInstuct{\n  padding: 10px 0px 0px 10px;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
